var includeFancybox = true;

$(document).ready(function() {

    // Main dropdown functions
    $('.main-nav > li').each(function() {
        var t = null;
        var li = $(this);
        li.hover(function() {
            t = setTimeout(function() {
                li.find("ul").slideDown('fast', 'easeOutExpo');
                li.find('a:first').addClass('active');
                t = null;
            }, 300);
        }, function() {
            if (t) {
                clearTimeout(t);
                t = null;
            } else
                li.find('ul:first').slideUp('fast', 'easeOutExpo');
            li.find('a:first').removeClass('active');
        });
    });

    // Find parents & add class
    $('.main-nav li:has(> ul)').find(">:first-child").addClass('parent');

    if (window.location.pathname == '/') {
        $('#target-nav > li:first-child, #target-nav > li:first-child > a').removeClass('normal').addClass('current');
    }

    // Save main nav html
    var targetNav = $('#target-nav').html();

    $('.mobile-nav').html(targetNav);

    var navHtml1 = $('.main-nav-wrap-1 .main-nav').html();
    var navHtml2 = $('.main-nav-wrap-2 .main-nav').html();
    var navHtml3 = $('.main-nav-wrap-3 .main-nav').html();
    var metanavHtml = $('.meta-nav').html();
    var searchHtml = $('.meta-nav li:last-child').html();

    $('.mobile-nav > li:first-child').append('<ul>' + navHtml1 + '</ul><div class="indicator"><i class="icon evu-arrow-down"></i></div>');
    $('.mobile-nav > li:nth-child(2)').append('<ul>' + navHtml2 + '</ul><div class="indicator"><i class="icon evu-arrow-down"></i></div>');
    $('.mobile-nav > li:nth-child(3)').append('<ul>' + navHtml3 + '</ul><div class="indicator"><i class="icon evu-arrow-down"></i></div>');

    $('.mobile-meta-nav').html(metanavHtml);
    $('#mobile-search').html(searchHtml);
    $('.mobile-nav .parent').parent().append('<div class="indicator"><i class="icon evu-arrow-down"></i></div>');

    $('.frontend-slider > .homepage-slider').bxSlider({
        mode: "fade",
        speed: 1500,
        // pager: ($('.homepage-slider').children().length <= 2) ? false : true,
        // auto: ($('.homepage-slider').children().length <= 2) ? false : true,
        pager: true,
        auto: true,
        autoHover: true,
        pause: 5000,
        responsive: true,
        preloadImages: 'visible',

        onSlideBefore: function($slideElement) {
            ($slideElement).find('.slide-caption').fadeOut().animate({ top: '100px' }, { queue: false, easing: 'easeOutQuad', duration: 550 });
            ($slideElement).find('.slide-caption').hide().animate({ top: '-100px' });
        },
        onSlideAfter: function($slideElement) {
            ($slideElement).find('.slide-caption').fadeIn().animate({ top: '0' }, { queue: false, easing: 'easeOutQuad', duration: 450 });
        },

        onSliderLoad: function() {
            $('.bx-controls-direction').hide();
            $('.bx-wrapper').hover(
                function() { $('.bx-controls-direction').fadeIn(300); },
                function() { $('.bx-controls-direction').fadeOut(300); }
            );
        }

    });

    

    var updateMenu = function() {

        var index = $('#target-nav li.active').index();
        if (index == -1) {
            index = $('#target-nav li.current').index();
        }
        index = index + 1;

        switch (index) {
            case 2:
                $('.main-nav-wrap').hide();
                $('.main-nav-wrap-2').show();
                break;
            case 3:
                $('.main-nav-wrap').hide();
                $('.main-nav-wrap-3').show();
                break;
            case 1:
            default:
                $('.main-nav-wrap').hide();
                $('.main-nav-wrap-1').show();
                break;
        }
    }
    updateMenu();

    $('.backend-slider > .homepage-slider').bxSlider({
        mode: "fade",
        speed: 1000,
        pager: true,
        auto: false,
        responsive: true,
        slideSelector: '.slide',
        preloadImages: 'visible',


        onSlideBefore: function($slideElement) {
            ($slideElement).find('.slide-caption').fadeOut().animate({ top: '100px' }, { queue: false, easing: 'easeOutQuad', duration: 550 });
            ($slideElement).find('.slide-caption').hide().animate({ top: '-100px' });
        },
        onSlideAfter: function($slideElement) {
            ($slideElement).find('.slide-caption').fadeIn().animate({ top: '0' }, { queue: false, easing: 'easeOutQuad', duration: 450 });
        },

        onSliderLoad: function() {
            $('.bx-controls-direction').hide();
            $('.bx-wrapper').hover(
                function() { $('.bx-controls-direction').fadeIn(300); },
                function() { $('.bx-controls-direction').fadeOut(300); }
            );
        }

    });

    // Set Header-Teaser as Background-Image + Add Class to Breadcrumb-Nav

    // if (jQuery('#home .neos-contentcollection > .typo3-neos-nodetypes-image').length == 1) {
    //     var el = jQuery('#home .neos-contentcollection > .typo3-neos-nodetypes-image');
    //     var img = jQuery('img', el).attr('src');

    //     el.attr('style', 'background-image: url("' + img + '");');

    //     jQuery('#home, #breadcrumb-nav').addClass('header-exists');

    // }
    // if (jQuery('#content .neos-contentcollection > .typo3-neos-nodetypes-image').length == 1) {

    //     jQuery('#breadcrumb-nav').addClass('header-exists');

    // }


    // Change Preisrechner Submit Value Text

    $('.preisrechner-fullwidth .preisrechner-submit input[type=submit]').val('Jetzt berechnen');
    $('.preisrechner-fullwidth.homepage').attr('id', 'preisrechner');

    $(document).on('smartweb.preisrechner', function(event) {
        // console.log('preisrechner event triggered', event.type, event.action, event.status);
        if (event.action == 'calculation' && event.status == 'complete') {
            $('.preisrechner-active input[type=submit]').val('Aktualisieren');
        }
    });

    // Change Preisrechner Headline Value Text
    $('.preisrechner-fullwidth .preisrechner-block.preisrechner-strom .preisrechner-input .preisrechner-form-container .preisrechner-form .preisrechner-headline h3').text('Stromtarif einfach wechseln. Finden Sie Ihren passenden SWN Stromtarif.');
    $('.preisrechner-fullwidth .preisrechner-block.preisrechner-gas .preisrechner-input .preisrechner-form-container .preisrechner-form .preisrechner-headline h3').text('Gastarif einfach wechseln. Finden Sie Ihren passenden SWN Gastarif.');


    $('.preisrechner-fullwidth.preisrechner-fullwidth-left-nav .preisrechner-block.preisrechner-strom .preisrechner-input .preisrechner-form-container .preisrechner-form .preisrechner-headline h3').text('Ihr Stromangebot: Jetzt hier berechnen.');
    $('.preisrechner-fullwidth.preisrechner-fullwidth-left-nav .preisrechner-block.preisrechner-gas .preisrechner-input .preisrechner-form-container .preisrechner-form .preisrechner-headline h3').text('Ihr Gasangebot: Jetzt hier berechnen.');
    // Change Preisrechner No Result Text
    $(document).on('smartweb.preisrechner', function(event) {
        if (event.action == 'calculation' && event.status == 'complete') {
            $('.preisrechner-neos-smartweb .preisrechner-block .calculation-result .no-results-found').html('Leider wurde mit Ihren Angaben kein passender Tarif gefunden. <br>Bitte wenden Sie sich an unseren Kundenservice.');
        }
    });

    // Add span-Tag to video-play-button
    $('.preview-image .play-button').wrapInner('<span>');

});

$(document).on("scroll", function() {

    if ($(document).scrollTop() > 85) {
        $("body").addClass("is-sticky");
    } else {
        $("body").removeClass("is-sticky");
    }

});
